import { defineComponent, computed, ref, onMounted, getCurrentInstance } from "vue";
import FormPanel from "@/views/creative/components/form-panel.vue";
import useIdToFindCategory from "@/views/creative/utils/use-id-to-find-category";
import { useModelStore } from "@/views/creative/model-editor/model-mixin";
import Resource from "@/views/creative/components/resource.vue";
import ResListHandler from "@/views/creative/components/res-list-handler.vue";
import ResourceList from "@/views/creative/components/resource-list.vue";
import UpdateResourceButton from "@/views/creative/template/update-resource-button.vue";
import { ElSchemaFormItem } from "el-schema-form";
import _ from "lodash";
import { PtButtonType, PtButtonTheme, PtButtonSize } from "@com/pt-components/pt-button/enum";
export default defineComponent({
    components: {
        UpdateResourceButton: UpdateResourceButton,
        ResourceList: ResourceList,
        ResListHandler: ResListHandler,
        Resource: Resource,
        FormPanel: FormPanel,
        ElSchemaFormItem: ElSchemaFormItem
    },
    props: {
        modelAnimation: {
            type: Object,
            required: true
        }
    },
    setup: function setup(props) {
        var handleChange = function handleChange(param) {
            var prop = param.prop, value = param.value;
            var data = _.cloneDeep(animationModel.value);
            data[prop] = value;
            store.commit("creative/modelEditor/setAnimationModel", data);
        };
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var store = root.$store;
        var _$ref1 = useModelStore(store), templateCategory = _$ref1.templateCategory, resource = _$ref1.resource, animationModel = _$ref1.animationModel;
        var renderLazyComponent = ref(false);
        var animationCategory = computed(function() {
            var _$ref;
            return useIdToFindCategory({
                category: templateCategory.value,
                categoryId: (_$ref = props.modelAnimation) === null || _$ref === void 0 ? void 0 : _$ref.category_id
            });
        });
        var innerResourceList = computed(function() {
            var _$ref;
            return resource.value[(_$ref = props.modelAnimation) === null || _$ref === void 0 ? void 0 : _$ref.category_id];
        });
        var defaultResourceId = computed(function() {
            return innerResourceList.value[0].id;
        });
        var speedFormItem = computed(function() {
            return {
                prop: "speed",
                component: "slider",
                field: {
                    min: 0.2,
                    max: 5,
                    step: 0.1,
                    showTooltip: false
                }
            };
        });
        var rotateFormItem = computed(function() {
            return {
                prop: "rotate",
                component: "slider",
                field: {
                    min: 0,
                    max: 360,
                    step: 1,
                    showTooltip: false
                }
            };
        });
        var handleSelectResource = function() {
            console.log("handleSelectResource");
        };
        var handleDblSelectResource = function() {
            console.log("handleDblSelectResource");
        };
        var handleUpdateTop = function() {
            console.log("handleUpdateTop");
        };
        onMounted(function() {
            setTimeout(function() {
                renderLazyComponent.value = true;
            });
        });
        return {
            animationCategory: animationCategory,
            innerResourceList: innerResourceList,
            resource: resource,
            defaultResourceId: defaultResourceId,
            handleSelectResource: handleSelectResource,
            handleDblSelectResource: handleDblSelectResource,
            handleUpdateTop: handleUpdateTop,
            renderLazyComponent: renderLazyComponent,
            speedFormItem: speedFormItem,
            handleChange: handleChange,
            PtButtonType: PtButtonType,
            PtButtonTheme: PtButtonTheme,
            PtButtonSize: PtButtonSize,
            rotateFormItem: rotateFormItem
        };
    }
});
